import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Table, Card, Button, Space, Tag, Typography, Form, Input, InputNumber, Select, Drawer,
  Radio, Upload, Descriptions, Statistic, Row, Col, Popconfirm, message, Modal, Alert
} from 'antd';
import { SearchOutlined, ReloadOutlined, PlusOutlined, DownloadOutlined } from '@ant-design/icons';
import SearchSelect from '../../../components/SearchSelect/SearchSelect';

const { Title, Text } = Typography;

const STATUS_MAP = {
  pending: { text: '待审核', color: 'processing' },
  listed: { text: '已上架', color: 'success' },
  rejected: { text: '已驳回', color: 'error' },
  delisted: { text: '已下架', color: 'default' },
};

// TODO: 联调时替换为接口数据
const MOCK_SOLUTIONS = [
  { key: '1', productName: '智能云台摄像机方案', productId: 'P_ECO_001', category: '摄像机', status: 'listed', openRange: 'public', selectCount: 3, totalAuth: 1500, totalDevice: 1200, openFwProd: 2, openFwUpg: 1, listTime: '2026-04-20 10:00:00', rejectReason: null, hardwarePrice: 89.00 },
  { key: '2', productName: '4G低功耗电池摄像机方案', productId: 'P_ECO_002', category: '摄像机', status: 'listed', openRange: 'public', selectCount: 1, totalAuth: 500, totalDevice: 320, openFwProd: 1, openFwUpg: 1, listTime: '2026-04-18 14:30:00', rejectReason: null, hardwarePrice: 129.00 },
  { key: '3', productName: '智能门铃方案', productId: 'P_ECO_003', category: '摄像机', status: 'rejected', openRange: 'directed', directedMode: 'designated', selectCount: 0, totalAuth: 0, totalDevice: 0, openFwProd: 0, openFwUpg: 0, listTime: '2026-04-15 09:00:00', rejectReason: '方案描述不够详细，缺少技术参数说明，请补充后重新提交', hardwarePrice: 65.00 },
  { key: '4', productName: 'NVR网络录像机方案', productId: 'P_ECO_004', category: '存储类', status: 'pending', openRange: 'public', selectCount: 0, totalAuth: 0, totalDevice: 0, openFwProd: 0, openFwUpg: 0, listTime: '2026-04-22 11:00:00', rejectReason: null, hardwarePrice: 199.00 },
  { key: '5', productName: '户外枪机方案', productId: 'P_ECO_005', category: '摄像机', status: 'delisted', openRange: 'public', selectCount: 2, totalAuth: 800, totalDevice: 600, openFwProd: 1, openFwUpg: 0, listTime: '2026-03-10 09:00:00', rejectReason: null, hardwarePrice: 159.00 },
];

const MOCK_USAGE = [
  { key: '1', entName: '东莞康林物联网有限公司', entId: 'ENT_M01', derivedName: '智能云台摄像机-康林高配版', derivedId: 'P_DERIVED_001', selectTime: '2026-04-21 10:00:00', authCount: 800, deviceCount: 650 },
  { key: '2', entName: '成都云视科技有限公司', entId: 'ENT_M02', derivedName: '智能云台摄像机-云视标准版', derivedId: 'P_DERIVED_002', selectTime: '2026-04-22 14:00:00', authCount: 500, deviceCount: 400 },
  { key: '3', entName: '东莞康林物联网有限公司', entId: 'ENT_M01', derivedName: '智能云台摄像机-康林低配版', derivedId: 'P_DERIVED_003', selectTime: '2026-04-23 09:00:00', authCount: 200, deviceCount: 150 },
];

const PARTNER_OPTIONS = [
  { label: '合作企业', value: 'partner', children: [
    { label: '东莞康林物联网有限公司', value: 'ENT_M01' },
    { label: '成都云视科技有限公司', value: 'ENT_M02' },
    { label: '广州云联物联网有限公司', value: 'ENT_M03' },
  ]},
];

// 选用时的目标企业（派生产品归属方）
const TARGET_ENT_OPTIONS = [
  { value: 'self', label: '本企业（方案商自身，客户未入驻平台时由方案商代管）' },
  ...PARTNER_OPTIONS[0].children.map((e) => ({ value: e.value, label: `${e.label}（${e.value}）` })),
];

// 可选的自研已发布产品（过滤已加入生态方案库的）
const MOCK_AVAILABLE_PRODUCTS = [
  { productId: 'PAtst9esf5', productName: '复制_真实设备调试产品2', category: '存储类', enterpriseName: '瀚晖通讯' },
  { productId: 'PP2zkp5WHi', productName: '2501', category: '摄像机', enterpriseName: '瀚晖通讯' },
];

// TODO: 联调时替换为真实接口
const fetchEntOptions = (keyword) =>
  new Promise((resolve) => setTimeout(() => resolve(
    PARTNER_OPTIONS[0].children.filter((e) => e.label.includes(keyword)).map((e) => ({ value: e.value, label: e.label }))
  ), 300));

// TODO: 联调时替换为真实接口
const fetchProductOptions = (keyword) =>
  new Promise((resolve) => setTimeout(() => resolve(
    MOCK_SOLUTIONS.filter((p) => p.productName.includes(keyword)).map((p) => ({ value: p.productId, label: p.productName }))
  ), 300));

const MySolutions = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [listForm] = Form.useForm();
  // 上架抽屉
  const [listDrawerVisible, setListDrawerVisible] = useState(false);
  const [listDrawerMode, setListDrawerMode] = useState('create'); // create | edit
  const [listRecord, setListRecord] = useState(null);
  const [openRange, setOpenRange] = useState('public');
  const [directedMode, setDirectedMode] = useState('partnerOnly'); // partnerOnly=仅合作企业可见 | designated=指定合作企业可见
  // 使用统计抽屉
  const [statsVisible, setStatsVisible] = useState(false);
  const [statsRecord, setStatsRecord] = useState(null);
  // 选用方案弹窗
  const [selectModalVisible, setSelectModalVisible] = useState(false);
  const [selectRecord, setSelectRecord] = useState(null);
  const [derivedName, setDerivedName] = useState('');
  const [targetEnt, setTargetEnt] = useState('self');
  // 添加方案抽屉
  const [addSchemeVisible, setAddSchemeVisible] = useState(false);
  const [addSchemeForm] = Form.useForm();
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleSelect = (record) => {
    setSelectRecord(record);
    setDerivedName(`${record.productName}-我的企业`);
    setTargetEnt('self');
    setSelectModalVisible(true);
  };

  const handleConfirmSelect = () => {
    if (!derivedName.trim()) { message.warning('请输入派生产品名称'); return; }
    const targetLabel = TARGET_ENT_OPTIONS.find((o) => o.value === targetEnt)?.label || '';
    const owner = targetEnt === 'self' ? '本企业' : targetLabel.split('（')[0];
    message.success(`选用成功，派生产品「${derivedName}」归属：${owner}`);
    setSelectModalVisible(false);
  };

  const openAddScheme = () => {
    setSelectedProduct(null);
    addSchemeForm.resetFields();
    // 添加方案默认选中「定向开放 - 仅合作企业可见」
    setOpenRange('directed');
    setDirectedMode('partnerOnly');
    setAddSchemeVisible(true);
  };

  const handleAddSchemeSubmit = async () => {
    try {
      await addSchemeForm.validateFields();
      if (!selectedProduct) { message.warning('请选择产品'); return; }
      message.success('已提交上架申请，请等待平台审核');
      setAddSchemeVisible(false);
    } catch (e) { /* */ }
  };

  const openListDrawer = (record, mode) => {
    setListRecord(record);
    setListDrawerMode(mode);
    setOpenRange(record?.openRange || 'public');
    setDirectedMode(record?.directedMode || 'partnerOnly');
    if (mode === 'edit' && record) {
      listForm.setFieldsValue({ description: '基于海思Hi3516DV300的全功能云台摄像机方案...', techParams: '主控：Hi3516DV300 | 传感器：IMX307', contact: 'solution@xinshijie.com' });
    } else {
      listForm.resetFields();
    }
    setListDrawerVisible(true);
  };

  const handleListSubmit = async () => {
    try {
      await listForm.validateFields();
      message.success(listDrawerMode === 'create' ? '已提交上架申请，请等待平台审核' : '方案信息已更新');
      setListDrawerVisible(false);
    } catch (e) { /* */ }
  };

  const openStats = (record) => { setStatsRecord(record); setStatsVisible(true); };

  const columns = [
    {
      title: '方案产品', key: 'product', width: 220,
      render: (_, r) => (<div><div style={{ fontWeight: 500, color: '#1890ff', cursor: 'pointer' }} onClick={() => navigate(`/product/info?id=${r.productId}`)}>{r.productName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.productId}</Text></div>),
    },
    { title: '产品类目', dataIndex: 'category', width: 200 },
    { title: '上架状态', dataIndex: 'status', width: 90, render: (v) => <Tag color={STATUS_MAP[v]?.color}>{STATUS_MAP[v]?.text}</Tag> },
    { title: '开放范围', dataIndex: 'openRange', width: 80, render: (v) => <Tag color={v === 'public' ? 'blue' : 'orange'}>{v === 'public' ? '公开' : '定向'}</Tag> },
    { title: '硬件定价', dataIndex: 'hardwarePrice', width: 100, align: 'right', render: (v) => v != null ? `¥${v.toFixed(2)}` : '-' },
    {
      title: '选用企业数', dataIndex: 'selectCount', width: 100, align: 'center',
      render: (v, r) => v > 0 ? <Button type="link" size="small" style={{ padding: 0, fontWeight: 600 }} onClick={() => openStats(r)}>{v} 家</Button> : <span style={{ color: '#ccc' }}>0</span>,
    },
    { title: 'License总数', dataIndex: 'totalAuth', width: 110, align: 'right', render: (v) => v > 0 ? <Text strong>{v.toLocaleString()}</Text> : <span style={{ color: '#ccc' }}>0</span> },
    { title: '设备总数', dataIndex: 'totalDevice', width: 100, align: 'right', render: (v) => v > 0 ? <Text strong>{v.toLocaleString()}</Text> : <span style={{ color: '#ccc' }}>0</span> },
    { title: '上架时间', dataIndex: 'listTime', width: 170 },
    {
      title: '驳回原因', dataIndex: 'rejectReason', width: 120,
      render: (v) => v ? <Text type="danger" ellipsis={{ tooltip: v }} style={{ maxWidth: 100 }}>{v}</Text> : <span style={{ color: '#ccc' }}>-</span>,
    },
    {
      title: '操作', key: 'action', width: 200, fixed: 'right',
      render: (_, r) => {
        const actions = [];
        if (r.status === 'listed') actions.push(<Button key="stats" type="link" size="small" onClick={() => openStats(r)}>统计</Button>);
        if (r.status === 'listed' || r.status === 'rejected') actions.push(<Button key="edit" type="link" size="small" onClick={() => openListDrawer(r, 'edit')}>编辑</Button>);
        if (r.status === 'listed') actions.push(<Popconfirm key="delist" title="确认下架？" description="已选用的企业不受影响，新企业将无法再选用此方案。" onConfirm={() => message.success('已下架')}><Button type="link" size="small" danger>下架</Button></Popconfirm>);
        if (r.status === 'rejected') actions.push(<Button key="resubmit" type="link" size="small" onClick={() => openListDrawer(r, 'edit')}>重新提交</Button>);
        if (r.status === 'delisted') actions.push(<Button key="relist" type="link" size="small" onClick={() => openListDrawer(r, 'edit')}>重新上架</Button>);
        if (r.status === 'listed' || r.status === 'delisted') actions.push(<Button key="select" type="link" size="small" onClick={() => handleSelect(r)}>选用方案</Button>);
        return (
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            {actions.map((node, idx) => <div key={idx} style={{ width: '50%' }}>{node}</div>)}
          </div>
        );
      },
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}><Title level={4}>我的方案</Title></div>

      <Alert
        type="info"
        showIcon
        closable
        style={{ marginBottom: 16, borderRadius: 8 }}
        message={(
          <div>
            开放方案后，<b>指定合作伙伴</b>与<b>平台其他企业</b>即可选用你的方案产品，派生开发自己的产品，帮你拓展客户。
            <div style={{ marginTop: 4 }}>
              注意：方案需先开放才能被选用；<b>即便由本企业自己派生使用，也需先开放，否则无法使用</b>。
            </div>
          </div>
        )}
      />

      <Card bordered={false} style={{ marginBottom: 8, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Form form={form} layout="inline">
            <Form.Item style={{ marginRight: 8 }}>
              <Space.Compact>
                <Form.Item name="prodType" initialValue="name" noStyle><Select style={{ width: 100 }}><Select.Option value="name">产品名称</Select.Option><Select.Option value="id">产品ID</Select.Option></Select></Form.Item>
                <Form.Item noStyle shouldUpdate={(prev, cur) => prev.prodType !== cur.prodType}>
                  {({ getFieldValue }) => getFieldValue('prodType') === 'id'
                    ? <Form.Item name="prodValue" noStyle><Input placeholder="输入产品ID" allowClear style={{ width: 200 }} /></Form.Item>
                    : <Form.Item name="prodValue" noStyle><SearchSelect fetchOptions={fetchProductOptions} placeholder="搜索方案产品" style={{ width: 200 }} /></Form.Item>}
                </Form.Item>
              </Space.Compact>
            </Form.Item>
            <Form.Item name="status" style={{ marginRight: 8 }}><Select placeholder="上架状态" allowClear style={{ width: 120 }} options={Object.entries(STATUS_MAP).map(([k, v]) => ({ value: k, label: v.text }))} /></Form.Item>
            <Form.Item><Space><Button type="primary" icon={<SearchOutlined />}>查询</Button><Button icon={<ReloadOutlined />} onClick={() => form.resetFields()}>重置</Button></Space></Form.Item>
          </Form>
        </div>
      </Card>

      <Card bordered={false} style={{ borderRadius: 12 }}>
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
          <Button type="primary" icon={<PlusOutlined />} onClick={openAddScheme}>开放方案</Button>
        </div>
        <Table columns={columns} dataSource={MOCK_SOLUTIONS} rowKey="key" scroll={{ x: 1500 }} style={{ whiteSpace: 'nowrap' }}
          pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }} />
      </Card>

      {/* ══════════════════════════════════════════════ */}
      {/*  上架抽屉（PAGE-3） */}
      {/* ══════════════════════════════════════════════ */}
      <Drawer
        title={listDrawerMode === 'create' ? '上架到生态方案库' : `编辑方案信息 - ${listRecord?.productName || ''}`}
        width={640} open={listDrawerVisible} onClose={() => setListDrawerVisible(false)} destroyOnClose
        footer={<div style={{ textAlign: 'right', padding: '10px 16px' }}><Button onClick={() => setListDrawerVisible(false)} style={{ marginRight: 8 }}>取消</Button><Button type="primary" onClick={handleListSubmit}>提交上架申请</Button></div>}
      >
        {listRecord && (
          <Descriptions bordered column={1} size="small" style={{ marginBottom: 16 }}>
            <Descriptions.Item label="产品名称">{listRecord.productName}</Descriptions.Item>
            <Descriptions.Item label="产品ID">{listRecord.productId}</Descriptions.Item>
            <Descriptions.Item label="产品类目">{listRecord.category}</Descriptions.Item>
          </Descriptions>
        )}
        <Form form={listForm} layout="vertical">
          <Form.Item label="方案描述" name="description" rules={[{ required: true, message: '请输入方案描述' }]}>
            <Input.TextArea rows={4} placeholder="描述方案的卖点、适用场景" maxLength={500} showCount />
          </Form.Item>
          <Form.Item label="技术参数说明" name="techParams">
            <Input.TextArea rows={3} placeholder="主控、传感器、分辨率等技术参数" maxLength={500} showCount />
          </Form.Item>
          <Form.Item label="方案图片" name="images">
            <Upload listType="picture-card" multiple beforeUpload={() => false}><div><PlusOutlined /><div style={{ marginTop: 8, fontSize: 12 }}>上传图片</div></div></Upload>
          </Form.Item>
          <Form.Item label="方案文档" name="docs">
            <Upload beforeUpload={() => false}><Button icon={<PlusOutlined />}>上传文档</Button></Upload>
          </Form.Item>
          <Form.Item label="联系方式" name="contact"><Input placeholder="邮箱或电话" /></Form.Item>
          <Form.Item label="硬件定价（元，选填）" name="hardwarePrice">
            <InputNumber min={0} precision={2} placeholder="请输入硬件定价" style={{ width: '100%' }} addonAfter="元" />
          </Form.Item>
          <Form.Item label="开放范围" required>
            <Radio.Group value={openRange} onChange={(e) => setOpenRange(e.target.value)}>
              <Radio value="public">公开（所有人可见）</Radio>
              <Radio value="directed">定向开放</Radio>
            </Radio.Group>
          </Form.Item>
          {openRange === 'directed' && (
            <Form.Item label="定向开放方式" required>
              <Radio.Group value={directedMode} onChange={(e) => setDirectedMode(e.target.value)}>
                <Radio value="partnerOnly">仅合作企业可见</Radio>
                <Radio value="designated">指定合作企业可见</Radio>
              </Radio.Group>
            </Form.Item>
          )}
          {openRange === 'directed' && directedMode === 'designated' && (
            <Form.Item label="选择合作企业" name="directedEnts" rules={[{ required: true, message: '请选择合作企业' }]}>
              <SearchSelect fetchOptions={fetchEntOptions} mode="multiple" placeholder="搜索并选择企业" style={{ width: '100%' }} />
            </Form.Item>
          )}
        </Form>
      </Drawer>

      {/* ══════════════════════════════════════════════ */}
      {/*  使用统计抽屉（PAGE-5） */}
      {/* ══════════════════════════════════════════════ */}
      <Drawer title={`方案使用统计 - ${statsRecord?.productName || ''}`} width={960} open={statsVisible} onClose={() => setStatsVisible(false)} destroyOnClose>
        {statsRecord && (<>
          <Row gutter={16} style={{ marginBottom: 24 }}>
            <Col span={8}><Card bordered={false} style={{ background: '#f6ffed', borderRadius: 8 }}><Statistic title="选用企业" value={statsRecord.selectCount} suffix="家" valueStyle={{ color: '#52c41a', fontWeight: 'bold' }} /></Card></Col>
            <Col span={8}><Card bordered={false} style={{ background: '#e6f7ff', borderRadius: 8 }}><Statistic title="License总数" value={statsRecord.totalAuth} valueStyle={{ color: '#1890ff', fontWeight: 'bold' }} /></Card></Col>
            <Col span={8}><Card bordered={false} style={{ background: '#fff7e6', borderRadius: 8 }}><Statistic title="设备总数" value={statsRecord.totalDevice} valueStyle={{ color: '#fa8c16', fontWeight: 'bold' }} /></Card></Col>
          </Row>
          <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Text strong>选用企业明细</Text>
            <Button size="small" icon={<DownloadOutlined />} onClick={() => message.success('导出成功')}>导出</Button>
          </div>
          <Table size="small" dataSource={MOCK_USAGE} rowKey="key" scroll={{ x: 900 }} style={{ whiteSpace: 'nowrap' }} pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条` }}
            columns={[
              { title: '选用企业', key: 'ent', width: 220, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.entName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.entId}</Text></div>) },
              { title: '派生产品', key: 'derived', width: 220, render: (_, r) => (<div><div style={{ fontWeight: 500 }}>{r.derivedName}</div><Text type="secondary" style={{ fontSize: 12 }}>{r.derivedId}</Text></div>) },
              { title: '选用时间', dataIndex: 'selectTime', width: 170 },
              { title: 'License总数', dataIndex: 'authCount', width: 100, align: 'right', render: (v) => <Text strong>{v.toLocaleString()}</Text> },
              { title: '设备总数', dataIndex: 'deviceCount', width: 100, align: 'right', render: (v) => <Text strong>{v.toLocaleString()}</Text> },
            ]}
          />
        </>)}
      </Drawer>

      {/* ══════════════════════════════════════════════ */}
      {/*  添加方案抽屉 */}
      {/* ══════════════════════════════════════════════ */}
      <Drawer
        title="开放方案"
        width={640} open={addSchemeVisible} onClose={() => setAddSchemeVisible(false)} destroyOnClose
        footer={<div style={{ textAlign: 'right', padding: '10px 16px' }}><Button onClick={() => setAddSchemeVisible(false)} style={{ marginRight: 8 }}>取消</Button><Button type="primary" onClick={handleAddSchemeSubmit}>提交上架申请</Button></div>}
      >
        <Form form={addSchemeForm} layout="vertical">
          <Form.Item label="选择产品" required>
            <Select
              placeholder="请选择自研已发布产品"
              showSearch
              filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              options={MOCK_AVAILABLE_PRODUCTS.map(p => ({ value: p.productId, label: `${p.productName} (${p.productId})`, product: p }))}
              onChange={(val, option) => setSelectedProduct(option.product)}
              style={{ width: '100%' }}
            />
          </Form.Item>
          {selectedProduct && (
            <Card size="small" style={{ marginBottom: 16, background: '#fafafa' }} bodyStyle={{ padding: 12 }}>
              <Space size={24}>
                <span><Text type="secondary">产品名称：</Text><Text strong>{selectedProduct.productName}</Text></span>
                <span><Text type="secondary">产品ID：</Text><Text>{selectedProduct.productId}</Text></span>
              </Space>
            </Card>
          )}
          <Form.Item label="方案描述" name="description" rules={[{ required: true, message: '请输入方案描述' }]}>
            <Input.TextArea rows={4} placeholder="描述方案的卖点、适用场景" maxLength={500} showCount />
          </Form.Item>
          <Form.Item label="技术参数说明" name="techParams">
            <Input.TextArea rows={3} placeholder="主控、传感器、分辨率等技术参数" maxLength={500} showCount />
          </Form.Item>
          <Form.Item label="方案图片" name="images">
            <Upload listType="picture-card" multiple beforeUpload={() => false}><div><PlusOutlined /><div style={{ marginTop: 8, fontSize: 12 }}>上传图片</div></div></Upload>
          </Form.Item>
          <Form.Item label="方案文档" name="docs">
            <Upload beforeUpload={() => false}><Button icon={<PlusOutlined />}>上传文档</Button></Upload>
          </Form.Item>
          <Form.Item label="联系方式" name="contact"><Input placeholder="邮箱或电话" /></Form.Item>
          <Form.Item label="硬件定价（元，选填）" name="hardwarePrice">
            <InputNumber min={0} precision={2} placeholder="请输入硬件定价" style={{ width: '100%' }} addonAfter="元" />
          </Form.Item>
          <Form.Item label="开放范围" required>
            <Radio.Group value={openRange} onChange={(e) => setOpenRange(e.target.value)}>
              <Radio value="public">公开（所有人可见）</Radio>
              <Radio value="directed">定向开放</Radio>
            </Radio.Group>
          </Form.Item>
          {openRange === 'directed' && (
            <Form.Item label="定向开放方式" required>
              <Radio.Group value={directedMode} onChange={(e) => setDirectedMode(e.target.value)}>
                <Radio value="partnerOnly">仅合作企业可见</Radio>
                <Radio value="designated">指定合作企业可见</Radio>
              </Radio.Group>
            </Form.Item>
          )}
          {openRange === 'directed' && directedMode === 'designated' && (
            <Form.Item label="选择合作企业" name="directedEnts" rules={[{ required: true, message: '请选择合作企业' }]}>
              <SearchSelect fetchOptions={fetchEntOptions} mode="multiple" placeholder="搜索并选择企业" style={{ width: '100%' }} />
            </Form.Item>
          )}
        </Form>
      </Drawer>

      {/* ══════════════════════════════════════════════ */}
      {/*  选用方案弹窗 */}
      {/* ══════════════════════════════════════════════ */}
      <Modal title="选用方案产品" open={selectModalVisible} onCancel={() => setSelectModalVisible(false)} onOk={handleConfirmSelect} okText="确认选用" width={480} destroyOnClose>
        {selectRecord && (
          <div style={{ marginTop: 16 }}>
            <div style={{ background: '#f9f9f9', padding: 16, borderRadius: 8, marginBottom: 16 }}>
              <div style={{ marginBottom: 8 }}><Text type="secondary">方案产品：</Text><Text strong>{selectRecord.productName}</Text></div>
              <div><Text type="secondary">方案商：</Text><Text>{selectRecord.vendorName || '本企业'}</Text></div>
            </div>
            <div style={{ marginBottom: 8 }}><Text strong>派生产品名称 <Text type="danger">*</Text></Text></div>
            <Input value={derivedName} onChange={(e) => setDerivedName(e.target.value)} placeholder="请输入派生产品名称" maxLength={50} showCount />
            <div style={{ marginTop: 16, marginBottom: 8 }}><Text strong>目标企业（派生产品归属）</Text></div>
            <Select value={targetEnt} onChange={setTargetEnt} style={{ width: '100%' }} options={TARGET_ENT_OPTIONS} />
            <Text type="secondary" style={{ fontSize: 12 }}>
              可选择客户企业；客户未入驻平台时选择「本企业」，由方案商代管产品与设备。
            </Text>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default MySolutions;
